import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: 'AIzaSyAti-LIr1wHxeA-Xo5KoAar97rDSwuQMDA',
  authDomain: 'webs-devcodes.firebaseapp.com',
  projectId: 'webs-devcodes',
  storageBucket: 'webs-devcodes.firebasestorage.app', // Bucket correcto de Firebase Storage
  messagingSenderId: '747769869554',
  appId: '1:747769869554:web:4d1755d3d33d5610324c6b',
  measurementId: 'G-JVZ3WB99FC',
};

const app = initializeApp(firebaseConfig);

// Inicializamos Firestore
const db = getFirestore(app, 'web-work-with-us');

// Inicializamos Storage (usa el bucket por defecto del config)
const storage = getStorage(app);

console.log('Firebase conectado a Storage:', firebaseConfig.storageBucket);

export { db, storage };
